/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Features_Desk_RecoveryInputs */

const en_features_desk_recovery = /** @type {(inputs: Features_Desk_RecoveryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Legs ${i?.value}% recovered. Go lighter on the squat today.`)
};

const pl_features_desk_recovery = /** @type {(inputs: Features_Desk_RecoveryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nogi odpoczęte w ${i?.value}%. Dziś lżej na przysiadzie.`)
};

/**
* | output |
* | --- |
* | "Legs {value}% recovered. Go lighter on the squat today." |
*
* @param {Features_Desk_RecoveryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_recovery = /** @type {((inputs: Features_Desk_RecoveryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_RecoveryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_recovery(inputs)
	return en_features_desk_recovery(inputs)
});